var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "indonesia",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 32.03,
    viewBox: "0 0 32.03 32.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 15.698,
    cy: 16.015,
    rx: 15.698,
    ry: 16.015,
    transform: "translate(0.635)",
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M0,16.278A16.119,16.119,0,0,1,15.956,0,16.119,16.119,0,0,1,31.911,16.278",
    fill: "#a2001d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/ID.78f5ab8b55397ea0d6ca069a012abfad.svg";
export { ForwardRef as ReactComponent };